<template>
  <label class="inline-flex items-center mt-3">
    <input
      type="checkbox"
      class="form-checkboxtext-gray-600"
      checked
    ><span class="ml-2 text-gray-700">label</span>
  </label>
</template>

<script>
export default {

}
</script>

<style scoped>
.form-checkbox {
  height: 1.2rem;
  width: 1.2rem;
}
</style>
